// extracted by mini-css-extract-plugin
export default {"errorContainerWrapper":"errorContainerWrapper_PM1Zi7ZE","errorContainer":"errorContainer_W6b0JonN","bold":"bold_Tss0taB6","errorButton":"errorButton_mvYI6Ud1"};